module.exports = __webpack_public_path__ + "img/9788963714431.44066959.jpg";